import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";

export const requestNotificationPermission = async () => {
  try {
    /**
     * Firebase Messaging is not supported on HTTP
     * (except localhost).
     *
     * Skip everything when running on HTTP.
     *
     * Remove this block after migrating to HTTPS.
     */
    if (!window.isSecureContext) {
      console.log(
        "Application is running on HTTP. Firebase Messaging skipped."
      );
      return null;
    }

    if (!messaging) {
      console.log("Firebase Messaging is unavailable.");
      return null;
    }

    console.log("Starting notification permission...");

    const permission =
      await Notification.requestPermission();

    console.log("Notification Permission:", permission);

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    console.log(
      "VAPID KEY:",
      process.env.REACT_APP_FIREBASE_VAPID_KEY
    );

    const token = await getToken(messaging, {
      vapidKey:
        process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    console.log("FCM Token:", token);

    return token;
  } catch (error) {
    console.error(
      "FCM GENERATION ERROR:",
      error
    );

    return null;
  }
};